import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "@/features/about/AboutPage";
import { loadPublic } from "@/lib/guards";

export const Route = createFileRoute("/about")({
  beforeLoad: loadPublic,
  component: AboutPage,
});
